import SliderPaneComponent from "Components/CommonComponents/SliderPaneComponent";
import NotificationsCreateAndUpdate from "Pages/Notifications/NotificationsCreateAndUpdate";
import NotificationsFilter from "Pages/Notifications/NotificationsFilter";
import NotificationsTable from "Pages/Notifications/NotificationsTable";
import { useContext, useEffect, useState } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { MainPageDiv } from "utilFunctions/shared/StyledComponent/StyledComponent";
import "./index.css";
import useMasterContext from "Context/MasterContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  GET_NOTIFICATION,
  GET_NOTIFICATION_STATUS,
} from "utilFunctions/Constants/urlConstants";
import moment from "moment";
import { Card, Modal, ModalBody, ModalHeader } from "reactstrap";
import Paginator from "utilFunctions/shared/Paginator";
import ConfirmationMessage from "Components/CommonComponents/ConfirmationMessage";
import useDeleteData from "utilFunctions/CustomHooks/useDeleteData";
import { ToastContextDispatch } from "Context/CommonContext";
import { FexRoles } from "utilFunctions/Constants/Constants";
export interface TimeRangePickerIF {
  startTime: string;
  endTime: string;
}
const NotificationTableHeading = [
  { label: "Template ID", value: "templateId" },
  { label: "Next schedule at", value: "scheduleAt" },
  { label: "Last Executed At", value: "lastExecutedAt" },
  { label: "Updated By", value: "updatedBy" },
  { label: "Frequency", value: "frequency" },
  { label: "Region", value: "regionId" },
  { label: "Branch", value: "branchId" },
  { label: "Role", value: "role" },
  { label: "Actions", value: "notificationAction" },
];
const Notifications = () => {
  const { masters } = useMasterContext();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { screen }: any = useWindowSize();
  const [isOpenForm, setIsOpenForm] = useState<boolean>(false);
  const [selectedNotification, setSelectedNotification] = useState<any>("");
  const [inputText, setInputText] = useState<string>("");
  const [formLoading] = useState<boolean>(false);
  const [notificationsData, setNotificationsData] = useState<any[]>([]);
  const [sortOrder, setSortOrder] = useState("ASC");
  const [sortColumn, setSortColumn] = useState<any>("updatedAt");
  const [isSuccessSweetAlert, setIsSuccessSweetAlert] =
    useState<boolean>(false);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    totalCount: "",
    totalPage: "",
    currentPage: "",
    nextPage: "",
    nextPageUrl: "",
    previousPageUrl: "",
  });
  const [open, setOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dateRanges, setDateRanges] = useState<any>([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [notificationStatus, setNotificationsStatus] = useState<any>(null);
  const [isNotificationStatus, setIsNotificationStatus] =
    useState<boolean>(false);

  const { makeRequest: GetNotifications, loading: isLoader } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        setPagination({
          totalCount: data.totalCount,
          totalPage: data.totalPage,
          currentPage: data.currentPage,
          nextPage: data?.nextPage ? data.nextPage : 0,
          previousPageUrl: data?.previousPageUrl ? data.previousPageUrl : "",
          nextPageUrl: data?.nextPageUrl ? data.nextPageUrl : "",
        });
        setNotificationsData(data["data"]);
        setOpen(false);
      } else {
        setNotificationsData([]);
      }
      console.log(data);
    },
    (error) => {
      setNotificationsData([]);
      console.log(error);
    }
  );
  const { makeRequest: NotificationDeleteAPI } = useDeleteData(
    (data: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: data["message"],
      });
      clearInputHandler();
      getNotificationsHandler();
    },
    (error) => {
      console.log("error", error["response"]["data"]["message"]);
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["response"]["data"]["message"],
      });
    },
    "DELETE"
  );
  const { makeRequest: GetNotificationStatus } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        setNotificationsStatus(data["data"]);
        setIsNotificationStatus(true);
      } else {
        setNotificationsStatus(null);
        setIsNotificationStatus(false);
      }
      console.log(data);
    },
    (error) => {
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["message"]
      ) {
        console.log(
          "error===error",
          error,
          error["response"]["data"],
          error &&
            error["response"] &&
            error["response"]["data"] &&
            error["response"]["data"]["message"]
        );
        setNotificationsStatus(error["response"]["data"]["message"]);
        setIsNotificationStatus(true);
      } else {
        setNotificationsStatus(null);
        setIsNotificationStatus(false);
      }
    }
  );
  console.log(notificationStatus, isNotificationStatus, "error===error");

  const openFormHandler = () => {
    setIsOpenForm(!isOpenForm);
  };
  const handleInputTextHandler = (value: any) => {
    setInputText(value);
    let url = BASE_URL + GET_NOTIFICATION;
    url =
      url +
      `?offset=0&limit=${limit}&sortDir=${sortOrder}&sortBy=${sortColumn}`;
    if (value) {
      url = url + `&templateId=${value}`;
    }
    url = setDateRangesHandler(url);
    GetNotifications(url);
  };
  const setDateRangesHandler = (url: string) => {
    if (dateRanges[0].startDate != null && dateRanges[0].endDate != null) {
      return (url =
        url +
        `&startTime=${moment(
          dateRanges[0].startDate
        ).valueOf()}&endTime=${moment(dateRanges[0].endDate).valueOf()}`);
    }
    return url;
  };
  useEffect(() => {
    getNotificationsHandler();
  }, [currentPage, limit]);
  const getNotificationsHandler = () => {
    let url = BASE_URL + GET_NOTIFICATION;
    url =
      url +
      `?offset=${0}&limit=${limit}&sortDir=${sortOrder}&sortBy=${sortColumn}`;
    url = setDateRangesHandler(url);
    GetNotifications(url);
  };
  const clearInputHandler = () => {
    setInputText("");
    resetDateRangeHandler();
    let url = BASE_URL + GET_NOTIFICATION;
    url =
      url +
      `?offset=${0}&limit=${limit}&sortDir=${sortOrder}&sortBy=${sortColumn}`;
    GetNotifications(url);
  };
  useEffect(() => {
    if (dateRanges[0].startDate != null && dateRanges[0].endDate != null) {
      let url = BASE_URL + GET_NOTIFICATION;
      url =
        url +
        `?offset=0&limit=${limit}&sortDir=${sortOrder}&sortBy=${sortColumn}&startTime=${moment(
          dateRanges[0].startDate
        ).valueOf()}&endTime=${moment(dateRanges[0].endDate).valueOf()}`;
      GetNotifications(url);
    }
  }, [dateRanges]);
  const onEdit = (item: any) => {
    const obj = { ...item };
    obj["role"] = FexRoles.flatMap((ele: any) =>
      item.role?.includes(ele.label) ? [ele.value] : []
    );
    setSelectedNotification(obj);
    openFormHandler();
  };
  const onDelete = (item: any) => {
    console.log();
    setSelectedNotification(item);
    setIsSuccessSweetAlert(true);
  };
  const onView = (item: any) => {
    GetNotificationStatus(
      BASE_URL + GET_NOTIFICATION_STATUS + "?notifyId=" + item.id
    );
  };
  const deleteNotificationHandler = () => {
    NotificationDeleteAPI(
      BASE_URL + GET_NOTIFICATION + "?notifyId=" + selectedNotification.id
    );
  };
  const resetDateRangeHandler = () => {
    setDateRanges([
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ]);
  };
  const onLimitChange = (limit: number) => {
    setLimit(limit);
  };
  const toggle = () => {
    setIsNotificationStatus(!isNotificationStatus);
  };
  const ElmentDetail = ({ label, value }: any) => {
    return (
      <div className="d-flex flex-row align-items-center gap: 3">
        <span className="studentLabel">{label}</span>
        <span className="studentValue pl-3">{value}</span>
      </div>
    );
  };
  return (
    <MainPageDiv screen={screen}>
      <Modal isOpen={isNotificationStatus} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>Notification Status</ModalHeader>
        <ModalBody>
          {notificationStatus != "no execution found" ? (
            <>
              <ElmentDetail
                label={"Total Submitted :"}
                value={notificationStatus?.totalSubmitted || "0"}
              />
              <ElmentDetail
                label={"Total Executed :"}
                value={notificationStatus?.totalExecuted || "0"}
              />
            </>
          ) : (
            <>{notificationStatus}</>
          )}
        </ModalBody>
      </Modal>
      {isSuccessSweetAlert && (
        <ConfirmationMessage
          warning={false}
          warningMessage="Are you sure want to delete this notification?"
          onCancel={() => {
            setIsSuccessSweetAlert(false);
          }}
          onConfirm={() => {
            setIsSuccessSweetAlert(false);
            deleteNotificationHandler();
          }}
          isSuccessSweetAlert={isSuccessSweetAlert}
          message={
            "notification will not be visible to anyone once it is deleted"
          }
        />
      )}
      <NotificationsFilter
        open={open}
        setOpen={setOpen}
        dateRanges={dateRanges}
        setDateRanges={setDateRanges}
        isLoader={isLoader}
        inputText={inputText}
        setInputText={setInputText}
        handleInputTextHandler={handleInputTextHandler}
        openFormHandler={openFormHandler}
        clearInputHandler={clearInputHandler}
      ></NotificationsFilter>
      <NotificationsTable
        openFormHandler={openFormHandler}
        setSelectedNotification={setSelectedNotification}
        data={notificationsData}
        tableHeading={NotificationTableHeading}
        loader={isLoader}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        onEdit={onEdit}
        onDelete={onDelete}
        onView={onView}
      ></NotificationsTable>
      {isOpenForm && (
        <SliderPaneComponent
          width={"100%"}
          isPaneOpen={isOpenForm}
          hideHeader={true}
          onRequestClose={() => {
            setIsOpenForm(false);
            setSelectedNotification(null);
          }}
          bodyClassName="notificationsSlider"
        >
          <NotificationsCreateAndUpdate
            region={masters?.regions?.map((item: any) => ({
              id: item.regionCode,
              label: item.label,
              value: item.id,
            }))}
            formLoading={formLoading}
            openFormHandler={() => {
              openFormHandler();
              setSelectedNotification(null);
            }}
            selectedNotification={selectedNotification}
            setSelectedNotification={setSelectedNotification}
            getNotificationsHandler={getNotificationsHandler}
          />
        </SliderPaneComponent>
      )}
      <Card
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "batchTableContainer pt-0 pb-1 p-2 mr-0"
            : "ml-2 mr-0 mt-0 p-2"
        }
      >
        <Paginator
          module={"test"}
          pagination={pagination}
          pageChanged={(page: any) => setCurrentPage(page)}
          handlePaginationCall={(url: string) => {
            console.log(url);
            GetNotifications(url);
          }}
          totalItems={notificationsData?.length}
          limit={limit}
          onLimitChange={onLimitChange}
        />
      </Card>
    </MainPageDiv>
  );
};
export default Notifications;
